import { AccordionProvider } from '~/@mid_ui/accordion/AccordionContext'
import type { ProjectSchema } from '../projects/_project_types/project.types'
import { ProjectV1Detail } from './v1/ProjectV1Detail'
import { ProjectV2Detail } from './v2/ProjectV2Detail'
import { ProjectDetailBlur } from './project-detail_ui/project-detail-blur/ProjectDetailBlur'

type Props = {
  project: ProjectSchema
}

function ProjectDetail({ project }: Props) {
  if (project == null || !project.published) {
    // TODO: lepsi error handling pre tento case
    return <>404 - Project not found</>
  }

  const content = (() => {
    if (project.version === 'v2') return <ProjectV2Detail project={project} />

    return <ProjectV1Detail project={project} />
  })()

  return (
    <AccordionProvider>
      {content}
      {!project._hasUserAccessToProject && <ProjectDetailBlur />}
    </AccordionProvider>
  )
}

export { ProjectDetail }
